import currencyConverter from "../../assets/currencyConverter.jpeg";
import aboveAverage from "../../assets/aboveAverage.jpg";
import AmazonClone from "../../assets/AmazonClone.png";
import walmartClone from "../../assets/WalmartClone.png";

export const projectsData = [
  {
    id: 1,
    image: walmartClone,
    title: "Walmart Clone",
    category: "web dev",
    link: "https://walmart-clone-mauve.vercel.app/",
  },

  {
    id: 2,
    image: aboveAverage,
    title: "The Above Average Effect",
    category: "publications",
    link: "https://a.co/d/cRN67Ob",
  },
  {
    id: 3,
    image: AmazonClone,
    title: "Amazon2.0 Clone",
    category: "web dev",
    link: "https://amazon-clone-woad-phi.vercel.app/",
  },
  {
    id: 4,
    image: currencyConverter,
    title: "Currency Converter",
    category: "web dev",
    link: "https://currency-converter-ten-ruby.vercel.app/",
  },
];

// projects
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web dev",
  },
  {
    name: "publications",
  },
];
